import React from 'react';
import './TraineeList.css';

interface WeeklyTrainee {
  name: string;
  department: string;
  weeklyHours: number;
  status: 'At Risk' | 'Not At Risk';
  riskScore?: number;
  attendanceRate?: number;
  absentRate?: number;
  holidayRatio?: number;
}

interface WeeklyStudentsPanelProps {
  trainees: WeeklyTrainee[];
  loading?: boolean;
  filterAtRisk?: boolean;
}

const WeeklyStudentsPanel: React.FC<WeeklyStudentsPanelProps> = ({ 
  trainees, 
  loading = false,
  filterAtRisk = false
}) => {
  // Filter to show only at-risk students if requested
  const displayedTrainees = filterAtRisk 
    ? trainees.filter(trainee => trainee.status === 'At Risk')
    : trainees;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading trainee data...</p>
      </div>
    );
  }

  if (displayedTrainees.length === 0) {
    return (
      <div className="no-data-message">
        {filterAtRisk 
          ? 'No at-risk students found' 
          : 'No weekly trainee data available'}
      </div>
    );
  }

  return (
    <div className="trainee-table weekly-view">
      <table>
        <thead>
          <tr>
            <th>Trainee</th>
            <th>Department</th>
            <th>Weekly Hours</th>
            <th>Attendance Rate</th>
            <th>Risk Score</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {displayedTrainees.map((trainee, index) => (
            <tr key={index}>
              <td>{trainee.name}</td>
              <td>{trainee.department}</td>
              <td>{trainee.weeklyHours} hours</td>
              <td>
                {trainee.attendanceRate !== undefined 
                  ? `${Math.round(trainee.attendanceRate * 100)}%` 
                  : 'N/A'
                }
              </td>
              <td>
                {trainee.riskScore !== undefined 
                  ? trainee.riskScore.toFixed(2)
                  : 'N/A'
                }
              </td>
              <td>
                <span className={`status-badge ${trainee.status === 'At Risk' ? 'at-risk' : 'not-at-risk'}`}>
                  {trainee.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WeeklyStudentsPanel;

